import React from 'react';
import { maskRichText } from '../../masks';
import { menuAPI } from '../../InterfaceAPI/menuAPI';

const now = new Date().getTime();
const day = 86400 * 1000; // Number of milliseconds in a day
const twoDaysFromNow = now + day * 2;

class SelectedDishes extends React.Component {
  state = {
    menuSelections: [],
    isRequestOut: false
  };

  render() {
    const { menuSelections = [] } = this.state;
    const { instructions = '' } = this.props;

    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Menu</h3>
          </div>
          <div className="cms__bar-right">
            {this.props.isClient && this.renderEditServiceLink()}
          </div>
        </div>

        <div className="cms__section-body">
          <p className="p p--bold p--pad-bot">
            Selected Dishes{' '}
            <span className="p--green-text">
              {menuSelections.reduce((total, sel) => total + sel.quantity, 0)}
            </span>
          </p>

          <div className="selected-dishes">
            {this.renderSelectionHeader()}
            {menuSelections.map((selection, i) =>
              this.renderSelectionView(selection, i)
            )}
          </div>

          {instructions && (
            <div className="p--pad-top">
              <p className="p p--bold">Special Instructions</p>
              <div className="notes p">{maskRichText(instructions)}</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSelectionHeader = () => {
    return (
      <div className="row row--space-between row--pad row--border-bottom">
        <div className="p row__item row__item--fourth p--bold">Dish Name</div>
        <div className="p row__item row__item--fourth p--bold">
          Please share with us any dish specific requests
        </div>
      </div>
    );
  };

  renderEditServiceLink() {
    // if service occurs more than 48 hours from now
    let startTime = new Date(this.props.service.start_time).getTime();
    if (startTime > twoDaysFromNow) {
      return (
        <a
          className="a--blue"
          href={`/menu-selection/${this.props.service.id}`}
        >
          Edit
        </a>
      );
    }
  }

  renderSelectionView(selection, i) {
    const { notes, dish } = selection;
    const dishName = dish && 'name' in dish ? dish.name : '';
    const dishChildName = dish && 'child_name' in dish ? dish.child_name : '';

    // don't center row if notes present
    let className = 'row row--space-between row--pad';
    if (!notes) {
      className += ' row--centered';
    }

    return (
      <div className={className} key={i}>
        <div className="row__item row__item--fourth">
          <p className="p ">
            {dishName}{' '}
            <span className="p--em p--new-line">{dishChildName}</span>
          </p>
        </div>
        <div className="row__item row__item--fourth">
          <p className="p">{notes}</p>
        </div>
      </div>
    );
  }

  populateSelectionsFromAPI() {
    const { menuSelections = [] } = this.props;
    // get the dish ids to look up
    const dishIDs = menuSelections.map(menuSelection => menuSelection.dish_id);
    if (!dishIDs || dishIDs.length === 0) return;

    // search for the ids
    this.setState({ isRequestOut: true });

    this.getDishes(dishIDs)
      .then(dishes => {
        // update the menuSelections with the dish
        const menuSelections = [...this.props.menuSelections].map(
          menuSelection => {
            menuSelection.dish = dishes.find(
              dish => dish.id === menuSelection.dish_id
            );
            return menuSelection;
          }
        );
        this.setState({ menuSelections, isRequestOut: false });
      })
      .catch(err => console.log(err));
  }

  // get the dishes from the API
  getDishes = dishIds => {
    return Promise.all(dishIds.map(this.mapGetRequest));
  };

  mapGetRequest = id => menuAPI.getDish(id);

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.menuSelections !== this.props.menuSelections) {
      console.log('probably not called');
      this.populateSelectionsFromAPI();
    }
  }

  componentDidMount() {
    this.populateSelectionsFromAPI();
  }
}

export default SelectedDishes;



// WEBPACK FOOTER //
// ./src/components/shared/SelectedDishes.js